var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9608 24.5299V24.8278C41.9608 25.5861 41.3649 26.1819 40.6066 26.1819H16.2316C15.4733 26.1819 14.8774 25.5861 14.8774 24.8278V24.5299C14.8774 19.7632 16.0691 18.5715 20.8899 18.5715H35.9483C40.7691 18.5715 41.9608 19.7632 41.9608 24.5299Z",
    fill: "#0091FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2316 28.8901C15.4733 28.8901 14.8774 29.486 14.8774 30.2443V32.9526V35.6339C14.8774 40.4006 16.0691 41.5922 20.8899 41.5922H35.9483C40.7691 41.5922 41.9608 40.4006 41.9608 35.6339V32.9526V30.2443C41.9608 29.486 41.3649 28.8901 40.6066 28.8901H16.2316V28.8901Z",
    fill: "#0091FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3868 35.8164C56.3868 46.2977 47.9097 54.7747 37.4285 54.7747L40.2722 50.0352",
    stroke: "#0091FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6123 22.9378C1.6123 12.4566 10.0894 3.97949 20.5706 3.97949L17.7269 8.71908",
    stroke: "#0091FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC3);
export default __webpack_public_path__ + "static/media/C3.096d59aab2394b25d6f29750b3158688.svg";
export { ForwardRef as ReactComponent };